import { useQuery } from '@apollo/client'
import { ANALYTICS_STATION_GROUPS_QUERY } from 'components/common/analytics-report/AnalyticsStationGroupsQueries'
import { useStations } from 'components/common/hooks/useStations'
import { useAuth } from 'config/context/authContext'
import React, { createContext, useContext, useMemo } from 'react'
import { useErrorHandler } from 'react-error-boundary'

const StationGroupsContext = createContext()

export const StationGroupsContextProvider = ({ children }) => {
  const { isEdgeDataProUser } = useAuth()

  const { stationParentGroups } = useStations()

  // Memoize the timestamp to ensure it's stable across renders
  const timestamp = useMemo(() => new Date().toISOString(), [])
  // try {

  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   const { data, error, loading } = useQuery(ANALYTICS_STATION_GROUPS_QUERY, {
  //     notifyOnNetworkStatusChange: true,
  //     variables: {
  //       timestamp,
  //       groupBys: stationParentGroups,
  //     },
  //     fetchPolicy: 'network-only',
  //     skip: !stationParentGroups?.length || isEdgeDataProUser  // prevent query if stationParentGroups is not yet ready or if analytics tab isn't set to PERIOD_ANALYSIS
  //   })

  //   if (error) {
  //     throw error
  //   }

  //   // eslint-disable-next-line react-hooks/rules-of-hooks
  //   // useErrorHandler(error)

  //   const groups = data?.analyticsStationGroups?.groups ?? []

  //   return (
  //     <StationGroupsContext.Provider value={{ groups, groupsLoading: loading }}>
  //       {children}
  //     </StationGroupsContext.Provider>
  //   )
  // } catch (error) {
  //   console.error('Error in StationGroupsContextProvider:', error)

  return (
    <StationGroupsContext.Provider value={{
      groups: [
        {
          parentGroup: "All Stations",
          childGroups: [
            {
              name: "All Stations",
              stationsCount: "0",
              stationIds: [],
              groupId: "all-stations"
            }
          ]
        }
      ], groupsLoading: false
    }}>
      {children}
    </StationGroupsContext.Provider>
  )
  // }
}

export const useStationGroups = () => {
  const context = useContext(StationGroupsContext)
  if (!context) {
    return []
  }
  return context
}